export default {
    desc: 'Descripción',
    nom: 'Nombre',
    name: 'Nombre',
    description: 'Descripcion',
    display_name: 'Nombre a mostrar',
    password: 'Contraseña',
    dir_entrega: 'Dirección de entrega',
    moneda_id: 'Moneda',
    plazo_entrega:'Plazo de entrega',
    flete_id:'Flete',
    provincia_id:'Provincia',
    alicuota_id:'Alícuota',
    distribuidor_id:'Distribuidor',
    vendedor_id:'Vendedor',
    condicion_pago_id:'Condición de pago',
    cuit:'C.U.I.T.',
    rzon_soc:'Razón social',
    sector_economico_id:'Sector económico'
}


// WEBPACK FOOTER //
// ./resources/assets/js/lang/attributos.js